let activeIframe: HTMLIFrameElement | null = null

export const setActiveIframe = (iframe: HTMLIFrameElement | null) => {
  activeIframe = iframe
}

export const getActiveIframe = () => activeIframe ?? null
